import React from 'react'

const Contact = () => {
  return (
    <div className="text-6xl font-bold">
        Contact
    </div>
  )
}

export default Contact